import React from 'react'
import { Link } from 'react-router-dom'
import commonStyles from "../../Shared/commonStyles.module.css";
import styles from "./PersonalisationCTA.module.css";


function PersonalisationCTA() {
  return (
     <section className={`${commonStyles.section}`}>
      <div className={commonStyles.container}>
        <div className={styles.final}>
          <h2>Ready to create something truly personal? </h2>          
          <div className={commonStyles.heroCtas}>
            <Link to="/products" className={`${commonStyles.btn} ${commonStyles.btnPrimary} ${styles.button}`}>
              Browse Products
            </Link>
            <Link to="/occasions" className={`${commonStyles.btn} ${commonStyles.btnSecondary} ${styles.button}`}>
            Shop by Occasions
            </Link>
            
          </div>
        </div>
      </div>
    </section>
  )
}

export default PersonalisationCTA